module.exports = function() {
  return new Worker(__webpack_public_path__ + "b90ea5a17d98f0bf81f0.worker.js");
};